module.exports = __webpack_public_path__ + "static/media/Raleway-Thin.07ac22f3.ttf";